import React, { useState } from "react";
import "./Tooltip.scss";

function Tooltip({ delay, children, direction, className, content }) {
  let timeout;
  const [active, setActive] = useState(false);

  //causes update to component when it's already removed, error appears in console.
  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, delay || 400);
    return () => {
      clearTimeout(timeout);
    };
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  return (
    <>
      <div
        role={"tooltip"}
        className={`Tooltip-Wrapper ${className}`}
        onMouseEnter={showTip}
        onMouseLeave={hideTip}
      >
        {children}
        {active && <div className={`Tooltip-Tip ${direction || "top"}`}>{content}</div>}
      </div>
    </>
  );
}

export default Tooltip;
